/* Spanish catalog mirroring locale-supplier-country-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'purchaseDocs.removeAll': 'Quitar todo',
  'purchaseDocs.removeOne': 'Quitar {name} de la compra',
  'purchaseDocs.duplicateTitle': 'Posible asiento duplicado',
  'purchaseDocs.duplicateHelp': 'Revisa las compras anteriores antes de contabilizar. Aun así, puedes contabilizar.',
  'purchaseDocs.sameAttachment': 'El mismo archivo está adjunto más de una vez.',
  'purchaseDocs.sameFile': 'El mismo archivo se usa en el justificante {number} · {date}.',
  'purchaseDocs.sameDetails': 'El justificante {number} · {date} tiene la misma fecha y el mismo importe.',
  'purchaseFlow.listTitle': 'Lista de compras',
  'purchaseFlow.purchaseCount': 'Compras',
  'purchaseFlow.netPurchases': 'Compras netas',
  'purchaseFlow.netPurchasesHelp': 'Sin IVA, después de notas de crédito',
  'purchaseFlow.includingVat': 'Con IVA',
  'purchaseFlow.credited': 'Abonado',
  'purchaseFlow.creditable': 'Disponible para abonar',
  'purchaseFlow.creditAllocationHelp': 'Selecciona la factura antes de contabilizar para la asignación automática. Cualquier importe que supere el saldo pendiente permanece como crédito con el proveedor.',
  'err.supplierCredit.invalidAmount': 'El abono debe ser positivo y no puede superar el importe que aún no se ha abonado. Los pagos no reducen este límite.',
  'err.purchase.duplicateSupplierDocument': 'Este número de documento ya está registrado para este proveedor. Abre la factura o la nota de crédito existente.',
  'purchaseFlow.creditNote': 'Nota de crédito',
  'purchaseFlow.negativeWarning': 'Un importe de factura negativo es inusual, salvo que sea una nota de crédito.',
  'purchaseFlow.creditOriginal': 'Factura que se abona (opcional)',
  'purchaseFlow.standaloneCredit': 'Sin vínculo: crédito con el proveedor',
  'purchaseFlow.creditLinesRequired': 'Usa líneas nuevas y negativas para la nota de crédito. Contabilízala directamente; aquí no se admiten borradores ni edición.',
  'err.supplierCredit.unsupportedLines': 'Usa líneas de compra ordinarias para una nota de crédito de proveedor; el inventario, los activos y los tratamientos especiales de IVA requieren una corrección específica.',
  'registry.toggleSupplierHelp': 'Sugiere empresas noruegas mientras escribes el nombre del proveedor o el número de empresa.',
  'sup.foreignToggle': 'Proveedor extranjero',
  'sup.foreignToggleHelp': 'Actívalo para proveedores registrados en un país distinto del de tu empresa.',
  'sup.countryCode': 'Código de país',
  'sup.countryCodePh': 'Ej.: SE o US',
  'sup.countryRequired': 'Introduce un código de país de dos letras para el proveedor extranjero.',
  'sup.registrationNumber': 'Número de registro',
  'sup.registrationNumberPh': 'El número de registro extranjero del proveedor',
  'sup.vatNumber': 'Número de IVA',
  'sup.vatNumberPh': 'Ej.: SE123456789001',
});
